import { createFileRoute, notFound } from '@tanstack/react-router';
import { type ViewParam, isValidView, type SubnavParam, type TypeParam, isValidSubNav, isValidType } from './-utils';

type SearchParams = {
  copyAudience?: boolean;
  isEdit?: boolean;
  isSystemTemplate?: boolean;
  seedId?: string;
  templateId?: string;
  usePassedRecipients?: boolean;
};

type Params = {
  id: string;
  subNav: SubnavParam;
  type: TypeParam;
  view: ViewParam;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/bulk_/$subNav_/$type_/$id_/$view')({
  params: {
    parse: (params): Params => {
      if (!isValidType(params.type)) {
        throw notFound();
      }
      if (!isValidSubNav(params.subNav)) {
        throw notFound();
      }
      if (!params.id) {
        throw notFound();
      }
      if (!isValidView(params.view)) {
        throw notFound();
      }
      return {
        ...params,
        id: params.id,
        subNav: params.subNav,
        type: params.type,
        view: params.view,
      };
    },
  },
  validateSearch: (search: Partial<SearchParams>): SearchParams => {
    return {
      copyAudience: search.copyAudience,
      isEdit: search.isEdit,
      isSystemTemplate: search.isSystemTemplate,
      seedId: search.seedId,
      templateId: search.templateId,
      usePassedRecipients: search.usePassedRecipients,
    };
  },
});
